import { render, staticRenderFns } from "./LoginDefault.vue?vue&type=template&id=470cd1a1&scoped=true&"
import script from "./LoginDefault.vue?vue&type=script&lang=js&"
export * from "./LoginDefault.vue?vue&type=script&lang=js&"
import style0 from "./LoginDefault.vue?vue&type=style&index=0&id=470cd1a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470cd1a1",
  null
  
)

export default component.exports